import { useTranslation } from 'react-i18next';

import { Button } from 'components/buttons';
import { ButtonWithLoading } from 'components/buttons/buttonWithLoading';
import { Panel } from 'components/containers';
import IconCross from 'components/icons/cross';
import { ModalControls } from 'components/modal/styles';

import i18n from 'locales/i18next';

import { formatNumberI18n } from 'utils/i18n';

import { FORM_FIELDS, FormFieldType } from '../form/keys';
import LABELS from '../keys';
import {
  ConfirmationAmount,
  ConfirmationEmail,
  ConfirmationLabel,
  ConfirmationModalContent,
  ConfirmationTo,
  Delimiter,
  StyledButtons,
  StyledConfirmationDialog,
} from '../styles';

interface ConfirmationModalProps {
  isOpen: boolean;
  isLoading: boolean;
  formValues: Record<FormFieldType, any>;
  onConfirm: () => void;
  onCancel: () => void;
}

export const ConfirmationModal = ({ isOpen, isLoading, formValues, onConfirm, onCancel }: ConfirmationModalProps) => {
  const { t } = useTranslation();

  return (
    <StyledConfirmationDialog open={isOpen} scroll="body" disableEscapeKeyDown fullWidth>
      <Panel
        label={t(LABELS.CONFIRMATION_MODAL.TITLE)}
        controls={
          <ModalControls>
            <Button flat onClick={onCancel}>
              <IconCross />
            </Button>
          </ModalControls>
        }
      >
        <ConfirmationModalContent>
          <ConfirmationLabel>{t(LABELS.CONFIRMATION_MODAL.REFUND_AMOUNT)}</ConfirmationLabel>
          <ConfirmationAmount>
            {formatNumberI18n(i18n.language)(formValues[FORM_FIELDS.FIAT_AMOUNT])} {formValues[FORM_FIELDS.CURRENCY]}
          </ConfirmationAmount>
          <ConfirmationTo>{t(LABELS.CONFIRMATION_MODAL.TO)}</ConfirmationTo>
          <ConfirmationEmail>{formValues[FORM_FIELDS.EMAIL]}</ConfirmationEmail>
        </ConfirmationModalContent>
        <Delimiter />
        <StyledButtons>
          <Button secondary onClick={onCancel}>
            {t(LABELS.CONFIRMATION_MODAL.CANCEL)}
          </Button>
          <ButtonWithLoading isLoading={isLoading} primary onClick={onConfirm}>
            {t(LABELS.CONFIRMATION_MODAL.CONFIRM)}
          </ButtonWithLoading>
        </StyledButtons>
      </Panel>
    </StyledConfirmationDialog>
  );
};
